<template>
    <page-content>

        <common-table
                ref="table"
                path="web/thirdpart/openapp"
                :columns="columns">

            <template slot="search">
                <a-button ghost type="primary" @click="add">新增</a-button>
            </template>

            <template slot="disable" slot-scope="{record}">
                <a-switch :checked="record.disable" size="small" @click="clickDisable(record)"></a-switch>
            </template>

            <template slot="operation" slot-scope="{record}">
                <action-edit @click="edit(record)"></action-edit>
                <action-delete @click="remove(record)"></action-delete>
            </template>

        </common-table>

        <open-app-edit ref="editDrawer" @success="getList"></open-app-edit>

    </page-content>

</template>
<script>
    import OpenAppEdit from './OpenAppEdit'

    export default {
        components: {
            OpenAppEdit
        },
        data() {
            return {

            }
        },

        created() {

        },

        computed: {
            columns() {
                return [
                    {
                        title: '名称',
                        dataIndex: 'name'
                    },
                    {
                        title: '设备MAC',
                        dataIndex: 'mac',
                    },
                    {
                        title: 'AppId',
                        dataIndex: 'appId'
                    },
                    {
                        title: 'AppKey',
                        dataIndex: 'appKey',
                    },

                    // {
                    //     title: '创建时间',
                    //     dataIndex: 'createdAt'
                    // },
                    // {
                    //     title: '屏蔽',
                    //     dataIndex: 'disable',
                    //     scopedSlots: {customRender: 'disable'},
                    //     filters: [
                    //         {text: '正常', value: '1'},
                    //         {text: '已屏蔽', value: '0'}
                    //     ],
                    //     filterMultiple: false,
                    //     width: 80
                    // },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width: 80,
                        scopedSlots: {customRender: 'operation'}
                    }
                ]
            }
        },
        methods: {
            add() {
                this.$refs.editDrawer.show()
            },
            edit(record) {
                this.$refs.editDrawer.show(record)
            },

            clickDisable(record) {
                this.$put('web/app-forum', {
                    id: record.id,
                    disable: !record.disable
                }).then(r => {
                    this.getList()
                })
            },
            remove(record) {
                let that = this
                this.$confirm({
                    title: '是否删除该记录?',
                    content: '该操作不可撤销',
                    centered: true,
                    onOk() {
                        that.$delete('web/thirdpart/openapp/' + record.id).then(() => {
                            that.$message.success('删除成功')
                            that.getList()
                        })
                    }
                })
            },
            getList() {
                this.$refs.table.getData()
            }

        }
    }
</script>
<style lang="less" scoped>

</style>
